<template>
    <div class="root">
        <label class="col-sm-12">
            Acesso
            <a @click.prevent="showform=true;focus()" v-if="showform==false" class="glyphicon glyphicon-plus" ></a>
            <small v-if="showform==true" class="text-primary"><b>Pressione ESC para sair</b></small>
        </label>
        <div v-if="showform" @keyup.enter="add()" @keyup.esc="reset()" class="col-sm-12 form">
            <div class="col-sm-5">
                <input type="text" v-model="iptEndereco" ref="iptendereco" placeholder="Endereço Externo" class="form-control">
            </div>
            <div class="col-sm-5">
                <input type="text" v-model="iptDescricao" placeholder="Endereço Local / Observações" class="form-control">
            </div>
            <div class="col-sm-5">
                <input type="text" v-model="iptUsuario" placeholder="Usuário" class="form-control">
            </div>
            <div class="col-sm-5">
                <input type="text" v-model="iptSenha" placeholder="Senha" class="form-control">
            </div>
            <div class="col-sm-2">
                <button @click.prevent="add()" class="btn btn-primary">Adicionar</button>
            </div>
        </div>
        <div class="col-sm-12">
            <ul class="list-inline">
                <li v-for="(acesso,index) in acessos">
                    <span class="text-primary">{{acesso.descricao}}</span><br/>
                    <small>{{acesso.endereco}}</small><br/>
                    <small><b>u:</b> {{acesso.u}}</small><br/>
                    <small><b>s:</b> {{acesso.s}}</small>
                    <a class="glyphicon glyphicon-pencil" @click.prevent="update(index)"></a>
                    <a class="glyphicon glyphicon-remove" @click.prevent="remove(index)"></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'acesso',
      props: ['acessos'],
      data () {
        return {
          showform: false,
          iptEndereco: '',
          iptDescricao: '',
          iptUsuario: '',
          iptSenha: '',
          index: -1
        }
      },
      methods: {
        add () {
          const item = {'endereco': this.iptEndereco, 'descricao': this.iptDescricao, 'u': this.iptUsuario, 's': this.iptSenha}
          this.$emit('add', item, 'acesso', this.index)
          this.reset()
        },
        update (index) {
          let acesso = this.acessos[index]
          this.iptEndereco = acesso.endereco
          this.iptDescricao = acesso.descricao
          this.iptUsuario = acesso.u
          this.iptSenha = acesso.s
          this.index = index
          this.showform = true
          this.focus()
        },
        remove (index) {
          this.$emit('remove', 'acesso', index)
        },
        focus () {
          this.$nextTick(() => { this.$refs.iptendereco.focus() })
        },
        reset () {
          this.showform = false
          this.iptEndereco = ''
          this.iptDescricao = ''
          this.iptUsuario = ''
          this.iptSenha = ''
          this.index = -1
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CliFormAcesso.vue